import useTranslation from "@/hooks/useTranslation";
import { NaviParams } from "@/interfaces/navi.interface";
import { SearchArticleType } from "@/interfaces/pubmed.interface";
import { Select } from "antd";
import React from "react";
import styles from "./styles.module.less";

const { Option } = Select;
const { wrapper, flex, label, full } = styles;

interface IProps {
  articleTypeFilterList: SearchArticleType[];
  setSearchParams: (searchParams: Partial<NaviParams>) => void;
}

const Type: React.FC<IProps> = ({ articleTypeFilterList, setSearchParams }) => {
  const onChange = (value: SearchArticleType[]) => {
    setSearchParams({ articleTypeFilterList: value });
  };

  const { t } = useTranslation("explore");

  return (
    <div className={wrapper}>
      <div className={flex}>
        <div className={label}>{t("pubmed.sidebar.article-types.itself")}</div>
      </div>
      <Select
        className={full}
        placeholder={t("pubmed.sidebar.select")}
        value={articleTypeFilterList}
        onChange={onChange}
        mode="multiple"
      >
        <Option value={SearchArticleType.REVIEW}>
          {t("pubmed.sidebar.article-types.review")}
        </Option>
        <Option value={SearchArticleType.GUIDELINE}>
          {t("pubmed.sidebar.article-types.guideline")}
        </Option>
        <Option value={SearchArticleType.CASE_REPORTS}>
          {t("pubmed.sidebar.article-types.case-reports")}
        </Option>
        <Option value={SearchArticleType.CLINICAL_STUDY}>
          {t("pubmed.sidebar.article-types.clinical-study")}
        </Option>
        <Option value={SearchArticleType.META_ANALYSIS}>
          {t("pubmed.sidebar.article-types.meta-analysis")}
        </Option>
        <Option value={SearchArticleType.MULTICENTER_STUDY}>
          {t("pubmed.sidebar.article-types.multicenter-study")}
        </Option>
        <Option value={SearchArticleType.RANDOMIZED_CONTROLLED_TRIAL}>
          {t("pubmed.sidebar.article-types.randomized-controlled-study")}
        </Option>
      </Select>
    </div>
  );
};

export default Type;
